import { messages } from './Appointments.i18n';

// The function goal is to create an array of objects that will be
// to the dropdown <option> tags
//
// HTML: <option value='{optionValue}'>{optionText}</option>
// {optionText}: text string
// {optionValue} json format:
// {
//    [filter attribute]: {optionText}
// }
const setupFilterDropdown = (firstOptionText, filterValue, filterOptions, attribute, className) => {
  // filterOptions parameter expects an array of stirngs.
  const options = filterOptions.map((optionText) =>
    ({
      optionText,
      optionValue: {
        [attribute]: optionText,
      },
    }));

  const defaultOptionValue = {
    [attribute]: '',
  };

  // insert as first item
  options.unshift(
    {
      optionText: firstOptionText,
      optionValue: defaultOptionValue,
    }
  );

  // Display filter value if present otherwise display text of the first option item.
  const selectedOptionValue = (filterValue ?
    {
      [attribute]: filterValue,
    } :
    defaultOptionValue);

  return {
    defaultOptionValue,
    value: selectedOptionValue,
    options,
    className,
  };
};

export const statusDropdownConfig = (props, formatMessage) => setupFilterDropdown(
  formatMessage(messages.filter.allStatuses),
  (props.filter && props.filter.status) ? props.filter.status : '',
  props.filterOptions.statuses,
  'status',
  'leftJustified'
);

export const providerDropdownConfig = (props, formatMessage) => setupFilterDropdown(
  formatMessage(messages.filter.allCareProviders),
  (props.filter && props.filter.provider) ? props.filter.provider : '',
  props.filterOptions.providers,
  'provider',
  'leftJustified'
);

export const apptTypeDropdownConfig = (props, formatMessage) => setupFilterDropdown(
  formatMessage(messages.filter.allTypes),
  (props.filter && props.filter.appointmentType) ? props.filter.appointmentType : '',
  props.filterOptions.appointmentTypes,
  'appointmentType',
  'leftJustified'
);

export const apptDateButtonGroupConfig = (props, formatMessage) => ({
  defaultValue: 'All',
  value: (props.filter) ? (props.filter.date || 'All') : 'All',
  id: 'date-filter-input-group',
  filterConfig: [
    {
      filterTitle: formatMessage(messages.filter.allDates),
      filterValue: 'All',
    },
    {
      filterTitle: formatMessage(messages.filter.upcomingDates),
      filterValue: 'Upcoming',
    },
    {
      filterTitle: formatMessage(messages.filter.pastDates),
      filterValue: 'Past',
    },
  ],
  xsSize: 12,
  smSize: 12,
  mdSize: 3,
});
